import React from 'react'

const PermissionContext = React.createContext([])

export const PermissionProvider = PermissionContext.Provider;

export default PermissionContext;